import(/* webpackMode: "eager" */ "/var/www/medconsult_pro/src/app/not-found.tsx");
